const MetricHeader = () => {
  return <div className="text-[#616161] text-sm">METRICS</div>;
};

export default MetricHeader;
